import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface basicInformation {
  contactFirstName: string
  contactLastName: string,
  requestorJobTitle: string,
  requestorMobileNumber: string
  contactWorkEmail: string
  whereYourCompanyHearAboutBIDProgram: string
  otherValueForBIDProgramReference: string
  requestorBusinessName: string
  businessOwnedOrCofoundedByUAE: string
  requestorCountryOrOrigin: string
  requestorCity: string
  requestorBusinessIncorporationYear: string
  requestorCompanyWebsiteURL: string
  registeredCompanyEmiratesReference: string
}
interface businessInformation {
  requestorBusinessModelType: string,
  otherTypeOfBusinessModel: string,
  requestorClientsListKey: string,
  requestorBusinessExplanation: string,
  requestorTechBusinessIndustrySector: string,
  requestorIndustryVertical: string,
  otherIndustryVertical: string
  numberOfEmployees: string,
  requestorAnnualRevenue: string,
  requestorCurrentBusinessValuation: string,
  requestorCompanyCurrentFundingStage: string,
  requestorOutsideHeadquarterCountires: string,
  corporatePresentation: File[],
  requestorPastCollaborationAndClientSize: string,
  requestorAnswerForTodaysSellInDubaiOrUAE: string,
  otherAnswerForTodaySell: string,
  introduceRequestorSpecificEntitiesInDubai: string,
  requestorReachedOutThemInPast: string,
  otherSpecificationForReachedOut: string,
  requestorWantedCategoriesToBeConnected: string,
  otherCategoriesWantedToConnectInDubai: string,
  howRequestorAreReadyToOpenCompany: string,
  requestorBiggestChallangesInUAEStratup: string,
  otherAnswerForChallanges: string,
  otherAnswerForDubaiStartup: string
}
interface formInformation {
  basicInformationDetails: basicInformation
  businessInformationDetails: businessInformation
}
const initialState: formInformation = {
  basicInformationDetails: {
    contactFirstName: "",
    contactLastName: "",
    requestorJobTitle: "",
    requestorMobileNumber: "",
    contactWorkEmail: "",
    whereYourCompanyHearAboutBIDProgram: "",
    otherValueForBIDProgramReference: "",
    requestorBusinessName: "",
    businessOwnedOrCofoundedByUAE: "",
    requestorCountryOrOrigin: "",
    requestorCity: "",
    requestorBusinessIncorporationYear: "",
    requestorCompanyWebsiteURL: "",
    registeredCompanyEmiratesReference: '',
  },
  businessInformationDetails: {
    requestorBusinessModelType: "",
    otherTypeOfBusinessModel: "",
    requestorClientsListKey: "",
    requestorBusinessExplanation: "",
    requestorTechBusinessIndustrySector: "",
    requestorIndustryVertical: "",
    otherIndustryVertical: "",
    numberOfEmployees: "",
    requestorAnnualRevenue: "",
    requestorCurrentBusinessValuation: "",
    requestorCompanyCurrentFundingStage: "",
    requestorOutsideHeadquarterCountires: "",
    corporatePresentation: [],
    requestorPastCollaborationAndClientSize: "",
    requestorAnswerForTodaysSellInDubaiOrUAE: "",
    otherAnswerForTodaySell: "",
    introduceRequestorSpecificEntitiesInDubai: "",
    requestorReachedOutThemInPast: "",
    otherSpecificationForReachedOut: "",
    requestorWantedCategoriesToBeConnected: "",
    otherCategoriesWantedToConnectInDubai: "",
    howRequestorAreReadyToOpenCompany: "",
    requestorBiggestChallangesInUAEStratup: "",
    otherAnswerForChallanges: "",
    otherAnswerForDubaiStartup: ""
  }
};

const basicInformationSlice = createSlice({
  name: "basicInformationSlice",
  initialState,
  reducers: {
    setBasicInformation(state, action: PayloadAction<any | {}>) {
      state.basicInformationDetails = action.payload;
    },
    setBusinessInformation(state, action: PayloadAction<any | {}>) {
      state.businessInformationDetails = action.payload;
    },
  },
});

export const { setBasicInformation, setBusinessInformation } = basicInformationSlice.actions;
export default basicInformationSlice.reducer;
